import { formattedValue } from './formatedValue';

export const isRangePicker = (isDateRange, isTimeRange) => isDateRange || isTimeRange;

export const hasTimeComponent = (isTime, isTimeRange) => isTime || isTimeRange;

export const getDisplayFormat = (baseFormat, value, isTime, isTimeRange) => {
  if (value && hasTimeComponent(isTime, isTimeRange)) return `${baseFormat} h:mm a`;
  return baseFormat;
};

export const getButtonText = ({
  value,
  baseFormat,
  buttonText,
  isDateRange,
  isTime,
  isTimeRange,
  timezone = null
}) => {
  const isRange = isRangePicker(isDateRange, isTimeRange);

  // Explicit button text always takes priority
  if (buttonText) return buttonText;

  if (value) {
    // Format values to match placeholder format
    let valueFormat;
    if (isTime || isTimeRange) {
      valueFormat = `${baseFormat}, h:mm a`;
    } else {
      valueFormat = baseFormat;
    }

    return formattedValue({
      value,
      format: valueFormat,
      isRange,
      timezone
    });
  }
  if (isTime) return `${baseFormat}, hh:mm`;
  if (isTimeRange && !isDateRange) return `${baseFormat}, hh:mm - hh:mm`;
  if (isTimeRange || (isTime && isDateRange)) return `${baseFormat}, hh:mm - ${baseFormat}, hh:mm`;
  if (isDateRange) return `${baseFormat} - ${baseFormat}`;

  // Default for isDate
  return baseFormat;
};
